/**
 * RemitSlice Extra Reducers
 * 
 * Handles RTK Query endpoint matchers for automatic state updates.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { RemitSliceState } from './state';
// import { accountApi } from '../accountApi';

/**
 * Build extra reducers for API endpoint matchers.
 * 
 * This function will be called by createSlice to add extra reducers
 * that respond to RTK Query endpoint lifecycle actions.
 * 
 * @param builder - The ActionReducerMapBuilder for adding cases
 */
export const buildRemitExtraReducers = (
  builder: ActionReducerMapBuilder<RemitSliceState>
): void => {
  // Placeholder for future RTK Query endpoint matchers
  // 
  // Example pattern (uncomment and modify when endpoints exist):
  //
  // builder
  //   .addMatcher(
  //     accountApi.endpoints.getRemit.matchFulfilled,
  //     (state, { payload }) => {
  //       state.currentRemit = payload;
  //       state.remitBackup = payload;
  //       state.isEdited = false;
  //       state.editedFields = [];
  //       state.validationErrors = {};
  //       state.selectedClaimId = null;
  //       state.selectedServiceLineId = null;
  //     }
  //   )
  //   .addMatcher(
  //     accountApi.endpoints.getRemit.matchPending,
  //     (state) => {
  //       state.isLoading = true;
  //     }
  //   )
  //   .addMatcher(
  //     accountApi.endpoints.getRemit.matchRejected,
  //     (state) => {
  //       state.isLoading = false;
  //     }
  //   );
};
